import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=f45df9b4&scoped=true&"
import script from "./contact-us.vue?vue&type=script&lang=js&"
export * from "./contact-us.vue?vue&type=script&lang=js&"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=f45df9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45df9b4",
  null
  
)

export default component.exports